// Handles tab navigation and smooth scrolling to tab content
export function initProductTabs({ tabsContainer }) {
    if (!tabsContainer) return;
    tabsContainer.addEventListener("click", (event) => {
        if (event.target.tagName === "A") {
            event.preventDefault();
            scrollToCenterTab(event.target);
        }
    });
}

function scrollToCenterTab(element) {
    const parent = element.closest(".tabs");
    if (!parent) return;
    const parentRect = parent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const scrollLeft = parent.scrollLeft;
    const offset = elementRect.left - parentRect.left + scrollLeft - parentRect.width / 2 + elementRect.width / 2;
    parent.scrollTo({ left: offset, behavior: "smooth" });
    const tabContent = document.querySelector(element.getAttribute("href"));
    if (tabContent) {
        tabContent.style.display = "block";
        requestAnimationFrame(() => {
            const tabContentRect = tabContent.getBoundingClientRect();
            const headerHeight = 110;
            const scrollToPosition = window.scrollY + tabContentRect.top - headerHeight;
            window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
        });
    }
}
